
import Vue from 'vue';
import { mapState } from 'vuex'

import CNavDrawer from './components/CNavDrawer.vue';

export default Vue.extend({
  name: 'App',
  components: { CNavDrawer },
  data(): any {
    return {
      ready: false
    }
  },
  computed: {
    ...mapState(['snackbar']),
  },
});
